module.exports = __webpack_public_path__ + "img/overview_blue.b5d41189.png";